import { useEffect } from 'react';

export function EnvironmentIndicator() {
    const rawEnv = import.meta.env.VITE_VERCEL_ENV || import.meta.env.VITE_APP_ENV || import.meta.env.VITE_ENV || 'production';
    // Normalize vercel's 'preview' env to our 'stage' equivalent
    const env = rawEnv === 'preview' ? 'stage' : rawEnv;

    useEffect(() => {
        if (env === 'production') return;

        const envName = env.toUpperCase();
        
        // Update Page Title
        document.title = `[${envName}] ROASForm Backoffice`;

        // Update Favicon based on environment
        const setFavicon = (color: string) => {
            const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
            if (link) {
                // Create a circular SVG favicon with the environment color
                const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="${color}" /></svg>`;
                const url = `data:image/svg+xml;base64,${btoa(svg)}`;
                link.href = url;
            }
        };

        if (env === 'dev') {
            setFavicon('#22c55e'); // Green
        } else if (env === 'stage') {
            setFavicon('#f97316'); // Orange
        }

        return () => {
            // Optional: Revert title on unmount if it was dynamically changing
        };
    }, [env]);

    if (env === 'production') {
        return null;
    }

    const isDev = env === 'dev';
    const bgColor = isDev ? 'bg-green-500' : 'bg-orange-500';
    const label = isDev ? 'Development Environment' : 'Staging Environment';

    return (
        <>
            {/* Top Bar (2px height) */}
            <div 
                className={`fixed top-0 left-0 right-0 h-1 z-[99999] shadow-sm ${bgColor}`} 
                style={{
                    // Adding "construction tape" stripes for staging to make it obvious without being intrusive
                    backgroundImage: !isDev 
                        ? 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(0,0,0,0.15) 10px, rgba(0,0,0,0.15) 20px)' 
                        : undefined
                }}
            />
            {/* Top Centered Dropdown Tab/Badge */}
            <div className={`fixed top-0 left-1/2 -translate-x-1/2 px-4 py-0.5 rounded-b-md text-[8px] font-semibold text-white tracking-wider z-[99999] shadow-md border border-t-0 border-white/10 ${bgColor} select-none pointer-events-none opacity-90 transition-opacity hover:opacity-100`}>
                {label}
            </div>
        </>
    );
}
